export default __webpack_public_path__ + "static/media/loja-ios.5ea6c32e.png";